const libFloat = {
	strBrToCurrency: function (valor) {
		//pega um valor tipo R$ 15.369,36
		//converte para 15369.36
		try {
			// Remove todos os caracteres que não são dígitos ou vírgulas
			valor = valor.replace(/[^\d,]/g, "");

			// Substitui a vírgula por ponto (formato decimal padrão)
			valor = valor.replace(",", ".");

			// Converte para número de ponto flutuante
			return parseFloat(valor) || 0;
		} catch (error) {
			return 0;
		}
	},

	strToCurrency: function strToCurrency(value) {
		if (typeof value === "string") {
			value = parseFloat(value.replace(",", "."));
		}
		const valor = new Intl.NumberFormat("pt-BR", {
			style: "currency",
			currency: "BRL",
		}).format(value);
		return valor;
	},
	strtoFloat: function (valor) {
		try {
			valor = new Intl.NumberFormat("pt-BR", {
				minimumFractionDigits: 2,
			}).format(valor);

			return valor;
		} catch (error) {
			return 0;
		}
	},
	formatarMoeda: function (valor) {
		try {
			//arruma o valor conforme digitado
			// remova todos os caracteres não numéricos //
			valor = valor.replace(/\D/g, "");
			// adicione os separadores de milhar e decimal // valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor / 100);
			valor = new Intl.NumberFormat("pt-BR", {
				minimumFractionDigits: 2,
			}).format(valor / 100);

			return valor;
		} catch (error) {
			return 0;
		}
	},
	formatToFloat: function (valor, fraction) {
		try {
			valor = valor.replace(/[^\d,]|(?<=,.*),/g, "");

			return valor;
		} catch (error) {
			return 0;
		}
	},
	parseNumber: function (str) {
		//corrigir valor mais de 10000.36
		try {
			const normalizedStr = str.replace(",", ".");
			return parseFloat(normalizedStr);
		} catch (error) {
			return 0;
		}
	},
	formatInteger: function (valor) {
		try {
			//arruma o valor conforme digitado
			// remova todos os caracteres não numéricos //
			valor = valor.replace(/\D/g, "");
			// adicione os separadores de milhar e decimal // valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor / 100);
			valor = valor;

			return valor;
		} catch (error) {
			return 0;
		}
	},
};

export default libFloat;
